import component from './MapViewConstructor.vue'
export default component
